import { Component } from './component';
import { Sales } from './sales';
import { Menu } from './menu';
import { Audit } from './audit';
import { Rebate } from './rebate';
import { SignUp } from './signUp';
import { Setting } from './setting';
import { Fund } from './fund';
import { Global } from './global';

export default {
    Component,
    Sales,
    Menu,
    Audit,
    Rebate,
    SignUp,
    Setting,
    Fund,
    Global,
};
